import debounceWithPromise from "views/logic/debounceWithPromise";
import validateQuery from "views/components/searchbar/queryvalidation/validateQuery";
const debouncedValidateQuery = debounceWithPromise(validateQuery, 350);
const validateForm = async (values, {
  setFieldWarning,
  pluggableValidationPayload = {},
  userTimezone
}) => {
  const errors = {};
  const queryValidation = await debouncedValidateQuery(
    {
      queryString: values == null ? void 0 : values.queryString,
      validation_mode: "SEARCH_FILTER",
      ...pluggableValidationPayload
    },
    userTimezone
  );
  if ((queryValidation == null ? void 0 : queryValidation.status) === "OK") {
    setFieldWarning("queryString", void 0);
  }
  if ((queryValidation == null ? void 0 : queryValidation.status) === "WARNING") {
    setFieldWarning("queryString", queryValidation);
  }
  if ((queryValidation == null ? void 0 : queryValidation.status) === "ERROR") {
    setFieldWarning("queryString", void 0);
    errors.queryString = queryValidation;
  }
  return errors;
};
export default validateForm;
